export default function SeaBattleIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="4" width="56" height="56" rx="10" fill="#0C4A8A" />
      <path d="M4 20h56M4 34h56M4 48h56M20 4v56M34 4v56M48 4v56" stroke="#3E7FC4" strokeWidth="1.5" />
      <path d="M10 40h40l-6 9H16z" fill="#C7D2E2" stroke="#46546B" strokeWidth="2" strokeLinejoin="round" />
      <rect x="22" y="32" width="14" height="8" rx="2" fill="#8794AB" stroke="#46546B" strokeWidth="2" />
      <rect x="27" y="25" width="4" height="7" fill="#46546B" />
      <circle cx="46" cy="18" r="9" fill="#FF8A1F" />
      <circle cx="46" cy="18" r="5" fill="#FFE27A" />
      <circle cx="16" cy="16" r="3.5" fill="#E6F3FF" />
      <path d="M4 52c5-3 9 3 14 0s9 3 14 0 9 3 14 0 9 3 14 0v8H4z" fill="#2F8BFF" />
    </svg>
  );
}
